import { asyncCallRoutePost } from '../helpers/api';
import { getCurrentCompositeConfiguration } from '../helpers/compositeProducts';

export class UpdateOrderItemPage {
	constructor( element, orderId, itemId ) {
		this.summeryInnerWrapper = element.querySelector( '.summary-inner-wrapper' );
		this.cartForm = element.querySelector( 'form.cart' );

		this.orderId = orderId;
		this.itemId = itemId;

		const productElement = element.querySelector( '.product' );
		this.productType = this.getProductType( productElement );
		this.productId = this.getProductId( productElement );

		this.routeUrl = window.QalaB2bWholesale.updateOrderRouteObj.routeUrl;
		this._wpnonce = window.QalaB2bWholesale.updateOrderRouteObj._wpnonce;
		this.viewOrderUrl = window.QalaB2bWholesale.viewOrderUrl + this.orderId;

		this.updateOrderItemText = window.QalaB2bWholesale.text.updateOrderItem;
		this.updatingOrderItemText = window.QalaB2bWholesale.text.updatingOrderItem;

		this.orderItemUpdateNotice = null;
		this.orderItemUpdateButton = null;

		this.getCompositeConfiguration = () => {};
	}

	/**
	 * Initialize the class
	 *
	 * @return {void}
	 */
	init() {
		this.setupOrderItemUpdateButton();
		this.setupOrderItemUpdateNotice();
		this.removeAddToCartButton();
	}

	/**
	 * Get the product id from the product element
	 *
	 * @param {HTMLElement} productElement
	 *
	 * @return {number} Product id
	 */
	getProductId( productElement ) {
		return +productElement.id.replace( 'product-', '' );
	}

	/**
	 * Get the product type from the product element
	 *
	 * @param {HTMLElement} productElement
	 *
	 * @return {string} Product type
	 */
	getProductType( productElement ) {
		let productType = null;

		productElement.classList.forEach( className => {
			if ( className.startsWith( 'product-type-' ) ) {
				productType = className.replace( 'product-type-', '' );
			}
		} );

		return productType;
	}

	/**
	 * Setup the order item update button
	 *
	 * @return {void}
	 */
	setupOrderItemUpdateButton() {
		this.orderItemUpdateButton = this.createUpdateOrderItemButton();
		this.cartForm.appendChild( this.orderItemUpdateButton );
	}

	/**
	 * Setup the order item update notice
	 *
	 * @return {void}
	 */
	setupOrderItemUpdateNotice() {
		this.orderItemUpdateNotice = this.createUpdateOrderItemNotice();
		this.cartForm.prepend( this.orderItemUpdateNotice );
	}

	/**
	 * Create the update order item button
	 *
	 * @return {HTMLButtonElement} Button
	 */
	createUpdateOrderItemButton() {
		const button = document.createElement( 'button' );

		button.classList.add( 'update-order-item-button', 'btn' );
		button.innerHTML = this.updateOrderItemText;
		button.addEventListener( 'click', this.updateOrderItem.bind( this ) );

		return button;
	}

	/**
	 * Create the update order item notice
	 *
	 * @return {HTMLDivElement} Notice
	 */
	createUpdateOrderItemNotice() {
		const notice = document.createElement( 'div' );
		notice.classList.add( 'update-order-item-notice' );
		return notice;
	}

	/**
	 * Remove the add to cart button
	 *
	 * @return {void}
	 */
	removeAddToCartButton() {
		this.cartForm.querySelector( 'button[type="submit"]' ).remove();
	}

	/**
	 * Set the update order item button loading state
	 *
	 * @param {boolean} enabled
	 *
	 * @return {void}
	 */
	setUpdateOrderItemButtonLoading( enabled ) {
		if ( enabled ) {
			this.orderItemUpdateButton.disabled = true;
			this.orderItemUpdateButton.innerHTML = this.updatingOrderItemText;
		} else {
			this.orderItemUpdateButton.disabled = false;
			this.orderItemUpdateButton.innerHTML = this.updateOrderItemText;
		}
	}

	/**
	 * Show the notice
	 *
	 * @param {string} message
	 */
	showNotice( message ) {
		this.orderItemUpdateNotice.innerHTML = message;
		this.orderItemUpdateNotice.classList.add( 'woocommerce-error' );
	}

	/**
	 * Update the order item
	 *
	 * @return {Promise<void>}
	 */
	async updateOrderItem() {
		this.setUpdateOrderItemButtonLoading( true );
		let fields = {};

		if ( this.productType === 'variable' ) {
			fields.variation_id = +this.summeryInnerWrapper.querySelector( 'input[name="variation_id"]' ).value;
		}

		if ( this.productType === 'composite' ) {
			fields = [];
			const compositeComponents = this.summeryInnerWrapper.querySelectorAll( '.composite_component' );

			compositeComponents.forEach( component => {
				const componentId = +component.dataset.item_id;
				const componentConfig = window.wc_cp_composite_scripts[ this.productId ].api.get_component_configuration( componentId );

				fields.push( {
					component_id: componentId,
					title: componentConfig.title,
					product_id: +componentConfig.product_id,
					variation_id: +componentConfig.variation_id,
					attributes: componentConfig.selection_meta,
				} );
			} );
		}

		try {
			const compositeConfiguration = getCurrentCompositeConfiguration();
			const response = await asyncCallRoutePost( this.routeUrl, this._wpnonce, {
				order_id: this.orderId,
				items_to_update: [
					{
						item_id: this.itemId,
						product_type: this.productType,
						fields,
						composite_configuration: compositeConfiguration ? JSON.stringify( compositeConfiguration ) : null,
					},
				],
			} );

			if ( response?.data?.status && response.data.status === 200 ) {
				window.location.href = this.viewOrderUrl;
			} else {
				this.showNotice( response.message );
				this.setUpdateOrderItemButtonLoading( false );
			}
		} catch ( e ) {
			this.setUpdateOrderItemButtonLoading( false );
		}
	}
}

